/**
 * DOM 조작을 위한 유틸리티 함수들
 */

/**
 * contenteditable 속성을 제거하는 함수
 */
export const removeContentEditable = (): void => {
  const previewContent = document.querySelector('.preview-content');
  if (previewContent) {
    const editableElements = previewContent.querySelectorAll('[contenteditable="true"]');
    editableElements.forEach(element => {
      element.removeAttribute('contenteditable');
    });
  }
};

/**
 * onclick 속성을 제거하는 함수
 */
export const removeOnclickAttributes = (): void => {
  const contentRef = document.querySelector('.preview-content');
  if (!contentRef) return;
  
  const amendmentTables = contentRef.querySelectorAll('.amendment-table');
  amendmentTables.forEach(table => {
    const addBtn = table.querySelector('.add-row-btn');
    const deleteBtn = table.querySelector('.delete-row-btn');
    if (addBtn) {
      addBtn.removeAttribute('onclick');
      addBtn.removeAttribute('onmousedown');
    }
    if (deleteBtn) {
      deleteBtn.removeAttribute('onclick');
      deleteBtn.removeAttribute('onmousedown');
    }
  });
};

/**
 * 이미지 크기를 조정하는 함수
 */
export const adjustImages = (): void => {
  const previewContent = document.querySelector('.preview-content');
  if (!previewContent) return;

  const images = previewContent.querySelectorAll('img');
  images.forEach(img => {
    const imgElement = img as HTMLImageElement;
    if (imgElement.naturalWidth > 0) {
      const maxWidth = previewContent.clientWidth;
      if (imgElement.naturalWidth > maxWidth) {
        imgElement.style.width = '100%';
        imgElement.style.height = 'auto';
      }
    }
  });
};

/**
 * DOM 변경을 감지하는 MutationObserver를 설정하는 함수
 */
export const setupDOMObserver = (
  target: Element | null,
  callback: () => void,
  options: MutationObserverInit = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['contenteditable', 'onclick', 'onmousedown']
  }
): MutationObserver | null => {
  if (!target) return null;

  const observer = new MutationObserver(callback);
  observer.observe(target, options);
  return observer;
};

/**
 * 지연 실행을 위한 유틸리티 함수
 */
export const executeWithDelay = (
  callback: () => void,
  delays: number[] = [100, 500, 1000]
): (() => void) => {
  const timers: NodeJS.Timeout[] = [];
  
  delays.forEach(delay => {
    timers.push(setTimeout(callback, delay));
  });

  // cleanup 함수 반환
  return () => {
    timers.forEach(timer => clearTimeout(timer));
  };
}; 

// 공통 DOM 조작 함수들
export const updateFormContent = (
  form: any, 
  contentRef: React.RefObject<HTMLDivElement>,
  delay: number = 10
): void => {
  if (!contentRef.current) return;
  
  // 비동기적으로 폼 값 업데이트하여 순환 참조 방지
  setTimeout(() => {
    form.setFieldValue('content', contentRef.current!.innerHTML);
  }, delay);
};

export const insertHTMLAtEnd = (
  contentRef: React.RefObject<HTMLDivElement>,
  html: string
): void => {
  if (!contentRef.current) return;
  contentRef.current.insertAdjacentHTML('beforeend', html);
};

export const scrollElementIntoView = (
  element: Element | null,
  behavior: ScrollBehavior = 'smooth',
  block: ScrollLogicalPosition = 'nearest'
): void => {
  if (element) {
    element.scrollIntoView({ behavior, block });
  }
};

export const setupGlobalTableHandlers = (): void => {
  if (typeof window !== 'undefined') {
    (window as any).addTableRow = function() {
      // 조용히 무시
    };
    (window as any).deleteTableRow = function() {
      // 조용히 무시
    };
  }
}; 